/* ---------- Collection "Search within" box (Oct 21 2026) ----------
 * The search box rendered its results but never hid the full product grid
 * (it looked for #CollectionProductGrid, which this theme does not have),
 * so it looked like nothing happened. This hides the grid while results
 * show, brings it back on Clear, and scrolls to results on "Show matches".
 */
(function () {
  'use strict';
  var init = function () {
    var roots = document.querySelectorAll('[data-ff-local-search]');
    if (!roots.length) return;
    var grid = document.getElementById('CollectionProductGrid') ||
      document.querySelector('.shopify-section[id$="__product-grid"]');
    roots.forEach(function (root) {
      var results = root.querySelector('[data-ff-search-results]');
      var form = root.querySelector('[data-ff-search-form]');
      if (!results) return;
      var sync = function () {
        if (results.hidden) {
          results.style.display = 'none';
          if (grid) grid.style.display = '';
        } else {
          results.style.display = '';
          if (grid) grid.style.display = 'none';
        }
      };
      new MutationObserver(sync).observe(results, { attributes: true, attributeFilter: ['hidden'] });
      sync();
      if (form) form.addEventListener('submit', function () {
        setTimeout(function () {
          if (!results.hidden) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 350);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
